import { useTheme } from '@emotion/react'
import { TabList } from '@mui/lab'
import { Box, Card, Chip, Tab, Typography } from '@mui/material'
import React from 'react'


const CustomTabs = ({ data = [], value, handleChange = () => { }, className: classes, isSmallScreen, titleStyle = {}, tabStyle, variant = "menu", indicatorFullSize = false, indicatorColor, bgColor, sx = {}, tabContainer={}, allowScrollButtonsMobile = false }) => {
    const theme = useTheme()

    const variantSwitch = (tabItem, index) => {
        switch (variant) {

            case 'submenu': return <Tab disableRipple value={tabItem?.value} sx={{ padding: tabStyle ? tabStyle?.padding : `${isSmallScreen ? "1rem 1rem 1rem 1rem" : '0rem 2rem 1rem'}` }} label={<>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: "0.4rem" }} >

                    {tabItem?.icon && <Box width={isSmallScreen ? "1rem" : "2rem"} height={isSmallScreen ? '1rem' : "2rem"} display={"grid"} sx={{
                        placeContent: 'center', background: 'transparent', borderRadius: '16px',
                        // transition: 'all 0.25s ease'
                    }}>
                        <tabItem.icon width={isSmallScreen ? 16 : 20} height={isSmallScreen ? 16 : 20}
                            sx={{ color: value === tabItem?.value ? theme.palette.customColors.indigo700 : '#191F29' }}
                            stroke={tabItem?.useStroke ? (value === tabItem?.value ? theme.palette.customColors.indigo700 : '#191F29') : ''}
                            fill={tabItem?.useStroke ? value === tabItem?.value ? theme.palette.customColors.indigo700 : '#191F29' : ''}
                        />
                    </Box>}
                    <Typography sx={{
                        fontSize: '1.25rem',
                        fontWeight: 700,
                        lineHeight: '24px',
                        textAlign: "center",
                        textTransform: 'capitalize',
                        color: theme.palette.customColors.g300,
                        ...titleStyle
                    }}>
                        {tabItem?.label}
                    </Typography>
                </div>

            </>} />

            default: return <Tab disableRipple value={tabItem?.value} sx={{ minWidth: 'auto', padding: tabStyle ? tabStyle?.padding : `${isSmallScreen ? "0.75rem 0rem" : '0rem 0rem 0.875rem'}` }} label={<>
                <div style={{ display: 'flex', alignItems: 'center', gap: "0.5rem" }} >

                    {tabItem?.icon && <Box width={isSmallScreen ? "1rem" : "2.5rem"} height={isSmallScreen ? '1rem' : "2.5rem"} display={"grid"} sx={{
                        placeContent: 'center', background: value === tabItem?.value ? theme.palette.customColors.indigo50 : 'transparent', borderRadius: '8px',
                        // transition: 'all 0.25s ease'
                    }}>
                        <tabItem.icon width={isSmallScreen ? 16 : 20} height={isSmallScreen ? 16 : 20} stroke={tabItem?.useStroke ? (value === tabItem?.value ? theme.palette.customColors.indigo700 : '#191F29') : ''} fill={tabItem?.useStroke ? 'transparent' : value === tabItem?.value ? theme.palette.customColors.indigo700 : '#191F29'} />
                    </Box>}
                    <Typography sx={{
                        fontSize: '0.95rem',
                        fontWeight: value === tabItem?.value ? 600 : 500,
                        lineHeight: '24px',
                        textAlign: "center",
                        textTransform: 'none',
                        transition: 'color 0.25s ease',
                        color: value === tabItem?.value ? theme.palette.customColors.g900 : theme.palette.customColors.g200
                    }}>
                        {tabItem?.label}
                    </Typography>
                </div>

            </>} />
        }
    }

    return (
        <>
            {/* <TabList
                sx={{
                    width: '100%',
                    overflow: 'hidden', // Ensure only one tab is visible at a time
                }}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                onChange={handleChange}
                aria-label="lab API tabs example"
                TabIndicatorProps={{
                    sx: {
                        bgcolor: indicatorFullSize ? theme.palette.customColors.indigo700 : 'transparent',
                        height: '1px',
                    },
                }}
            >
                {data?.map((tabItem, index) => (variantSwitch(tabItem, index)))}
            </TabList> */}

            <TabList sx={{
                width: '100%',
                
                background: bgColor ? bgColor : "#fffdfa",
                paddingBottom: variant === "submenu" ? '0.5rem' : '',
                border: variant === "submenu" ? '1px solid #e0e0e0' : '', 
                "& > .MuiTabs-scroller > .MuiTabs-flexContainer": {
                    gap: variant === "submenu" ? { xs: '1rem', sm: '2.5rem', md: '2.5rem' } : { xs: '1.25rem', sm: '1.5rem' },
                    paddingInline: variant === "submenu" ? '2rem' : '',
                    ...tabContainer
                },
                "& > .MuiTabs-scroller": {
                    overflowX: 'auto !important',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    "&::-webkit-scrollbar": { display: 'none' },
                }, borderRadius: variant === "submenu" ? '8px 8px 0 0' : 0, overflow: variant === "submenu" ? 'hidden' : 'auto', ...(variant === "submenu" ? { ...sx } : { paddingTop: { xs: "0rem", sm: '1rem' }, ...sx})
            }} variant='scrollable' scrollButtons={false} className={classes.scrollTabs}
                //  TabIndicatorProps={{ sx: { bgcolor: indicatorFullSize ? 'rgb(122 198 255 / 20%)' : theme.palette.customColors.indigo700,
                // MuiTabs-flexContainer : {marginLeft: '2rem', gap: '5rem'}
                TabIndicatorProps={{
                    sx: {
                        bgcolor: indicatorColor ? indicatorColor : (variant === "submenu" ? theme.palette.customColors.indigo700 : theme.palette.customColors.g900),
                        height: indicatorFullSize ? 0 : (variant === "submenu" ? '2px' : '2px'), borderRadius: variant === "submenu" ? '0 0' : '2px 2px 0 0'
                    }
                }}
                onChange={handleChange} aria-label="lab API tabs example">
                {data?.map((tabItem, index) => variantSwitch(tabItem, index)
                )}
            </TabList>
        </>
    )
}

export default CustomTabs